import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { STALE_TIME } from '@/api/staleTimes';
import { menuLabelListSchema, type MenuLabel } from '../types/menuLabel.types';

export const menuLabelQueryKeys = {
  all: () => ['menu-labels'] as const,
};

export const menuLabelsQueryOptions = () =>
  queryOptions({
    queryKey: menuLabelQueryKeys.all(),
    queryFn: async (): Promise<MenuLabel[]> => {
      const res = await apiClient.get(API.settingsLookups.menuLabels);
      return menuLabelListSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });

export async function setMenuLabels(labels: MenuLabel[]): Promise<void> {
  await apiClient.put(API.settingsLookups.menuLabels, { labels });
}
